module.exports = __webpack_public_path__ + "img/bk_golden.6a290414.png";